<template>
  <page-wrapper :title="pageWrapper.title" :has-pad="pageWrapper.hasPad">
    <div class="wrapper">
      <div class="row">
        <div class="col-3">
          <div class="label">โครงการ</div>
          <project-select v-model="query.project"></project-select>
        </div>
        <div class="col-2">
          <div class="label">บ้านเลขที่</div>
          <el-input v-model="query.homeNo" />
        </div>
        <div class="col-3">
          <div class="label">ชื่อลูกค้า</div>
          <el-input v-model="query.customerName" />
        </div>
        <div class="col-2">
          <div class="label">สถานะการติดต่อ</div>
          <el-select v-model="query.contactStatus" clearable>
            <el-option
              v-for="t in leadHomeStatusMapper"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="search">
        <div class="text-end mt-2 pe-2">
          <sc-button variant="warning" @click="handleClickClear"
            >clear</sc-button
          >
        </div>
        <div class="mt-2">
          <sc-button variant="primary" @click="handleClickSearch"
            >ค้นหา</sc-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-2">
          <router-link :to="leadLink" class="link back-page"
            >Lead ทั้งหมด >
          </router-link>
          <div class="link name">{{ nameRoute.name }}</div>
          <sc-button
            v-if="isPermissionManager"
            class="ms-5"
            variant="secondary"
            @click="handleClickDownloadReport"
            >download report
          </sc-button>
        </div>
        <div class="col-6 text-end mt-2">
          <sc-button
            v-if="isPermissionAgent"
            :disabled="!canBookingLead"
            variant="secondary"
            @click="handleClickBookingLeadForAgent"
            >ขอข้อมูลลูกค้า</sc-button
          >
        </div>
      </div>
      <div>
        <div v-if="!total" class="text-center">ไม่มีข้อมูล</div>
        <div v-if="total">
          <p class="mb-1 mt-2">{{ totalCount }}</p>
          <div class="lead-home-row header">
            <div class="cell">สถานะการขาย</div>
            <div class="cell">โครงการ</div>
            <div class="cell">บ้านเลขที่</div>
            <div class="cell">ชื่อลูกค้า</div>
            <div class="cell">แพ็กเกจที่ขาย</div>
            <div class="cell">ผู้รับผิดชอบการขาย</div>
            <div class="cell">แก้ไขล่าสุด</div>
            <div class="cell">หมายเหตุ</div>
          </div>
          <div class="mb-4">
            <router-link
              v-for="home in homeList"
              :key="home.id"
              :to="home.route"
              class="lead-home-row"
            >
              <div class="cell">
                <div
                  :class="home.statusClassList"
                  class="cell lead-status-badge"
                >
                  {{ home.statusTH }}
                </div>
                <div v-if="home.actionDate">{{ home.actionDate }}</div>
                <div v-if="home.reason">{{ home.reason }}</div>
              </div>
              <div class="cell">
                <div style="display: flex; align-items: center">
                  <div v-if="home.isFlag" class="show-noti me-2" />
                  {{ home.projectCode }}
                </div>
              </div>
              <div class="cell">{{ home.homeId }}</div>
              <div class="cell">{{ home.userName }}</div>
              <div>
                <div
                  v-for="(pack, index) in home.packagePurchases"
                  :key="index"
                  class="cell"
                >
                  {{ pack }}
                </div>
              </div>
              <div class="cell">{{ home.adminName }}</div>
              <div class="cell">{{ home.latestUpdate }}</div>
              <div class="cell">{{ home.remark }}</div>
            </router-link>
          </div>
          <div class="text-end">
            <el-pagination
              :total="total"
              :page-size="15"
              :current-page="+query.page"
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { Input, Pagination, Select, Option } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import { baanRueJaiClient } from "@/dependencies"
import ProjectSelect from "@/lib/components/ProjectSelect"
import {
  leadHomeManagementStatusTH,
  leadHomeStatusMapper,
  leadManagementReason,
  permissionRole,
} from "@/lib/mapper"
import { DateTime } from "luxon"
import PageWrapper from "../../../lib/components/PageWrapper"

export default {
  name: "LeadManagementHomePage",
  components: {
    PageWrapper,
    "el-input": Input,
    ScButton,
    ProjectSelect,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
  },
  data() {
    const query = {
      project: undefined,
      homeNo: undefined,
      customerName: undefined,
      contactStatus: undefined,
      page: 1,
    }

    const leadLink = { name: "LeadManagementPage" }

    return {
      query,
      total: 1,
      homeList: [],
      nameRoute: {},
      leadLink,
      permission:
        JSON.parse(localStorage.getItem("adminRolePermission")) || null,
      canBookingLead: false,
    }
  },
  computed: {
    totalCount() {
      const limit = 15
      const total = this.total.toLocaleString()
      const currentTotalItem = this.homeList.length
      const isLastPage = limit > currentTotalItem
      const currentPage = +this.query.page || 1
      const end = isLastPage ? total : currentPage * limit
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString()

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`
    },
    leadHomeStatusMapper() {
      return leadHomeStatusMapper
    },
    isPermissionAgent() {
      return this.permission.role === permissionRole.LMA
    },
    isPermissionManager() {
      return this.permission.role === permissionRole.LMM
    },
    pageWrapper() {
      return {
        title: "ข้อมูล Lead",
        hasPad: true,
      }
    },
  },
  watch: {
    "$route.query": function routeQueryWatcher() {
      this.setup()
    },
  },
  created() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupForm()
      this.setupData()
    },
    setupForm() {
      this.query = {
        project: this.$route.query.project || undefined,
        homeNo: this.$route.query.homeNo || undefined,
        customerName: this.$route.query.customerName || undefined,
        contactStatus: this.$route.query.contactStatus || undefined,
        page: this.$route.query.page || 1,
      }
    },
    setupData() {
      this.setupLeadHomeList()
    },
    async setupLeadHomeList() {
      this.homeList = []
      this.total = 0

      const {
        home_count: homeCount,
        lead_homes: leadHomes,
        name,
        can_booking_lead_home: canBookingLeadHome,
      } = await this.fetchData()

      this.canBookingLead = canBookingLeadHome

      this.homeList = leadHomes.map(this.mapLeadHomeToModel)

      const { id } = this.$route.params

      this.total = homeCount
      this.nameRoute = {
        name,
        id: { name: "LeadManagementHomePage", params: { id } },
      }
    },
    mapLeadHomeToModel(leadHome) {
      const {
        id,
        project_code: projectCode = "",
        home_no: homeId = "",
        user_name: userName = "",
        packages,
        admin_name: adminName = "-",
        status = "-",
        remark = "-",
        latest_update: latestUpdate = "-",
        is_flag: isFlag,
        action_date: actionDate = null,
        reason,
      } = leadHome

      const packagePurchases =
        packages && packages.length > 0
          ? packages.map((pack) => {
              const packageName = `${pack.name}(${pack.id})`
              const quantity = `จำนวน ${pack.quantity} แพ็กเกจ`
              return `- ${packageName}\n${quantity}`
            })
          : "-"

      const statusClassList = [status]
      const statusTH = leadHomeManagementStatusTH[status]
      const route = { name: "LeadManagementContactPage", params: { id } }
      const reasonLabel = reason
        ? leadManagementReason.find((i) => i.value === reason).label || null
        : null

      return {
        projectCode,
        homeId,
        userName,
        packagePurchases,
        adminName,
        statusTH,
        remark,
        route,
        statusClassList,
        latestUpdate,
        isFlag,
        actionDate,
        reason: reasonLabel,
        status,
      }
    },
    sortedLeads(leads) {
      if (!leads || leads.length === 0) {
        return []
      }

      const pendingList = []
      const otherList = []

      leads.forEach((lead) => {
        if (lead.status === "PENDING") {
          pendingList.push(lead)
        } else {
          otherList.push(lead)
        }
      })

      pendingList.sort((a, b) => {
        if (a.project_code < b.project_code) return -1
        if (a.project_code > b.project_code) return 1

        if (a.id < b.id) return -1
        if (a.id > b.id) return 1

        return 0
      })
      otherList.sort((a, b) => {
        if (a.lead_created_at > b.lead_created_at) return -1
        if (a.lead_created_at < b.lead_created_at) return 1

        return 0
      })

      const leadWithFollow = []
      const leadWithoutFollow = []

      otherList.forEach((lead) => {
        if (lead.isFlag) {
          leadWithFollow.push(lead)
        } else {
          leadWithoutFollow.push(lead)
        }
      })

      return [...pendingList, ...leadWithFollow, ...leadWithoutFollow]
    },
    async fetchData() {
      const { id } = this.$route.params

      const params = {
        project_id:
          this.query.project && this.query.project.projectId
            ? this.query.project.projectId
            : undefined,
        home_id: this.query.homeNo,
        customer_name: this.query.customerName,
        status: this.query.contactStatus,
        page: this.query.page,
      }

      const response = await baanRueJaiClient.admin.lead.homeList(id, params)

      return response.data.result
    },
    handleClickClear() {
      const query = {
        project: undefined,
        homeNo: undefined,
        customerName: undefined,
        contactStatus: undefined,
        page: 1,
      }

      this.$router.push({ query })
    },
    handleClickSearch() {
      const query = {
        project: this.query.project,
        homeNo: this.query.homeNo,
        customerName: this.query.customerName,
        contactStatus: this.query.contactStatus,
        page: 1,
      }

      this.$router.push({ query })
    },
    handleCurrentChange(page) {
      const query = {
        ...this.$route.query,
        page,
      }

      this.$router.push({ query })
    },
    async handleClickBookingLeadForAgent() {
      const { id } = this.$route.params

      await baanRueJaiClient.admin.lead.bookingLeadAgent(id)

      this.setup()
    },
    async handleClickDownloadReport(event) {
      event.preventDefault()
      const { id } = this.$route.params

      const params = {
        project_id:
          this.query.project && this.query.project.projectId
            ? this.query.project.projectId
            : undefined,
        home_id: this.query.homeNo,
        customer_name: this.query.customerName,
        status: this.query.contactStatus,
        page: this.query.page,
        format: "xlsx",
      }

      const response = await baanRueJaiClient.admin.lead.homeList(id, params)
      const now = DateTime.utc().toFormat("dd/MM/yyyy")
      const blob = new Blob([response.data])

      const link = document.createElement("a")
      link.href = window.URL.createObjectURL(blob)
      link.download = `lead-reports-${now}.xlsx`
      link.click()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";
.wrapper {
  padding: ($space / 2) $space;
}

.lead-home-row {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 100px 80px 80px 150px 200px 150px 100px 200px;
  width: max-content;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    color: #999;
    font-size: 14px;
  }

  > .status {
    text-align: center;
  }
}

.search {
  display: grid;
  grid-template-columns: 94% auto;
  border-bottom: $border;
}

.link {
  display: inline-block;
  opacity: 1;

  &.back-page {
    font-weight: normal;
    color: #999;
    font-size: 20px;
  }

  &.name {
    font-weight: bold;
    font-size: 22px;
  }
}

.show-noti {
  border-radius: 50%;
  background-color: rgb(252, 76, 76);
  color: rgb(252, 76, 76);
  width: 16px;
  height: 16px;
}
</style>
